import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { createContext, useContext, useMemo, useRef, useState } from 'react';
import { Accordion, Card, Bleed, Button, Tooltip, Flex, Text, Drawer, Box, StickyBar } from '@applyboard/crystal-ui';
import { PersonOutlineIcon, MenuLeftCollapseOutlineIcon, MenuLeftExpandOutlineIcon, BuildingOutlineIcon, StudentOutlineIcon, MoneyDollarOutlineIcon, ClipboardOutlineIcon, PersonTieOutlineIcon, WarningOutlineIcon, FlagOutlineIcon, GraduationCapOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker, useTranslation } from '@applyboard/ui-utils';
import { LegacyStatusCheckboxes } from '@applyboard/ab-application-legacy';
import { assert } from "../../../../utils/assert";
import { ApplicationDetails } from "./ApplicationDetails";
import { EducationBackground } from "./EducationBackground";
import { ExamDetails } from "./ExamDetails";
import { StudentDetails } from "./StudentDetails";
import { RecruitmentPartnerDetails } from "./RecruitmentPartnerDetails";
import { useApplication, useLegacyApplication, useOrderItem } from "../../data";
import { useReloadApplicationPageAggregatedData } from "../../data/aggregatedData";
import { PaymentDetails } from "./PaymentDetails";
import { useApplicationNotices } from "../../data/applicationNotices";
import { useApplicationRecruitmentPartner } from "../../data/recruitmentPartner";
import { ErrorBoundary } from 'react-error-boundary';
import { IllustratedErrorState } from "../../../../components/IllustratedErrorState";
import { useHistory } from 'react-router-dom';
import { CopyableContainer } from "../../../../components/Copyable/Copyable";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var SidebarContext = /*#__PURE__*/createContext({
  isOpen: true,
  onOpenChange: function onOpenChange() {}
});
export function SidebarProvider(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    onOpenChange = _ref.onOpenChange,
    maxHeight = _ref.maxHeight;
  return _jsx(SidebarContext.Provider, {
    value: useMemo(function () {
      return {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        maxHeight: maxHeight
      };
    }, [isOpen, onOpenChange, maxHeight]),
    children: children
  });
}
export function SideBarCard(_ref2) {
  var children = _ref2.children,
    maxHeight = _ref2.maxHeight;
  var _useContext = useContext(SidebarContext),
    isOpen = _useContext.isOpen,
    onOpenChange = _useContext.onOpenChange;
  var _useEventTracker = useEventTracker({
      group: 'Single Application V2'
    }),
    trackEvent = _useEventTracker.trackEvent;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var containerRef = useRef(null);
  var trackSideBarExpanded = function trackSideBarExpanded(sideBarExpanded) {
    trackEvent({
      event: 'Single Application V2-Sidebar-Clicked To Expand/ Collapse Sidebar',
      data: {
        sideBarExpanded: sideBarExpanded
      }
    });
  };
  var handleSideBarExpandedToggle = function handleSideBarExpandedToggle() {
    var newExpandedState = !isOpen;
    onOpenChange(newExpandedState);
    trackSideBarExpanded(newExpandedState);
  };
  return _jsx(Box, {
    width: isOpen ? {
      xs: 400,
      lg: 384,
      xl: 400
    } : 120,
    children: _jsx(Card, {
      "aria-label": "Application Sidebar",
      p: 0,
      children: _jsxs("div", {
        style: {
          maxHeight: maxHeight,
          overflowY: maxHeight ? 'auto' : undefined
        },
        ref: containerRef,
        children: [_jsx(StickyBar, {
          sticky: !!application.newView,
          top: 0,
          borderTopRadius: "container",
          containerRef: containerRef,
          children: _jsx(Flex, {
            justify: isOpen ? 'start' : 'center',
            px: isOpen ? 6 : 4,
            pt: 6,
            pb: 2,
            children: _jsx(Tooltip, {
              label: isOpen ? 'Collapse' : 'Expand',
              children: _jsx(Button, {
                emphasis: "highlighted",
                intent: "primary",
                "aria-label": "".concat(isOpen ? 'Collapse' : 'Expand', " side bar"),
                leadIcon: isOpen ? MenuLeftCollapseOutlineIcon : MenuLeftExpandOutlineIcon,
                onClick: handleSideBarExpandedToggle
              })
            })
          })
        }), _jsx(Box, {
          px: isOpen ? 6 : 4,
          pb: 6,
          children: children
        })]
      })
    })
  });
}
export function SideBar(_ref3) {
  var allowMultipleOpen = _ref3.allowMultipleOpen,
    copyEnabled = _ref3.copyEnabled,
    hiddenSections = _ref3.hiddenSections,
    paymentDetailsButton = _ref3.paymentDetailsButton;
  var _useEventTracker2 = useEventTracker({
      group: 'Single Application V2'
    }),
    trackEvent = _useEventTracker2.trackEvent;
  return _jsx(ErrorBoundary, {
    fallbackRender: function fallbackRender(_ref4) {
      var error = _ref4.error;
      return _jsx(IllustratedErrorState, {
        error: error,
        variant: "compact"
      });
    },
    onError: function onError(error) {
      return trackEvent({
        event: 'Single Application V2 - Sidebar - Displayed Error',
        error: error
      });
    },
    children: _jsx(SidebarContents, {
      allowMultipleOpen: allowMultipleOpen,
      copyEnabled: copyEnabled,
      hiddenSections: hiddenSections,
      paymentDetailsButton: paymentDetailsButton
    })
  });
}
export function SidebarDrawerButton(_ref5) {
  var sidebar = _ref5.sidebar,
    width = _ref5.width;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return _jsxs(Drawer, {
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "right",
    width: "sm",
    children: [_jsx(Drawer.Trigger, {
      children: _jsx(Button, {
        size: "sm",
        intent: "primary",
        emphasis: "highlighted",
        leadIcon: GraduationCapOutlineIcon,
        width: width,
        children: "Information panel"
      })
    }), _jsx(Drawer.Header, {
      children: "Information Panel"
    }), _jsx(CopyableContainer, {
      children: _jsx(SidebarContext.Provider, {
        value: {
          // Force the sidebar to be open when used in a drawer and ignore the root sidebar context
          // See: https://applyboard.slack.com/archives/C06ME2XT59V/p1745957933179169?thread_ts=1745863354.440729&cid=C06ME2XT59V
          isOpen: true,
          onOpenChange: function onOpenChange() {}
        },
        children: sidebar
      })
    })]
  });
}
function SidebarContents(_ref6) {
  var allowMultipleOpen = _ref6.allowMultipleOpen,
    copyEnabled = _ref6.copyEnabled,
    hiddenSections = _ref6.hiddenSections,
    paymentDetailsButton = _ref6.paymentDetailsButton;
  var _useContext2 = useContext(SidebarContext),
    isOpen = _useContext2.isOpen,
    onOpenChange = _useContext2.onOpenChange;
  var _useTranslation = useTranslation('SideBar'),
    t = _useTranslation.t;
  var history = useHistory();
  var _useHandleAccordionOp = useHandleAccordionOpen({
      allowMultipleOpen: allowMultipleOpen,
      onOpenChange: onOpenChange
    }),
    accordionValue = _useHandleAccordionOp.accordionValue,
    handleAccordionSectionExpandedToggle = _useHandleAccordionOp.handleAccordionSectionExpandedToggle;
  var _useReloadApplication = useReloadApplicationPageAggregatedData(),
    reloadApplicationPageAggregatedData = _useReloadApplication.reloadApplicationPageAggregatedData;
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var _useApplicationRecrui = useApplicationRecruitmentPartner(),
    recruitmentPartner = _useApplicationRecrui.recruitmentPartner;
  var _useApplicationNotice = useApplicationNotices(),
    warningNotices = _useApplicationNotice.warningNotices;
  var _useOrderItem = useOrderItem(),
    orderItem = _useOrderItem.orderItem;
  var hideChevron = !isOpen;
  return _jsxs(Accordion, {
    allowMultipleOpen: allowMultipleOpen,
    onChange: function onChange(newValue) {
      assert(Array.isArray(newValue));
      handleAccordionSectionExpandedToggle(newValue);
    },
    value: isOpen && accordionValue ? accordionValue : [],
    emphasis: "plain",
    px: 1,
    children: [_jsx(Accordion.Item, {
      id: "ApplicationStatus",
      title: _jsx(AccordionItemTitle, {
        isSideBarExpanded: isOpen,
        title: t('title.applicationStatus'),
        Icon: FlagOutlineIcon
      }),
      hideChevron: hideChevron,
      children: _jsx(AccordionItemContent, {
        isOpen: isOpen,
        children: _jsx(LegacyStatusCheckboxes, {
          aggregatedDataLegacyApplication: legacyApplication,
          reloadAggregatedData: reloadApplicationPageAggregatedData,
          history: history
        })
      })
    }, "ApplicationStatus"), _jsx(Accordion.Item, {
      id: "Application details",
      title: _jsx(AccordionItemTitle, {
        isSideBarExpanded: isOpen,
        title: t('title.applicationDetails'),
        Icon: StudentOutlineIcon,
        showWarningIcon: warningNotices.filter(function (notice) {
          return notice.importance !== 'high';
        }).some(function (notice) {
          return notice.regarding === 'application';
        })
      }),
      hideChevron: hideChevron,
      children: _jsx(AccordionItemContent, {
        isOpen: isOpen,
        children: _jsx(ApplicationDetails, {
          copyEnabled: copyEnabled,
          hiddenSections: hiddenSections
        })
      })
    }, "Application details"), _jsx(Accordion.Item, {
      id: "Student",
      title: _jsx(AccordionItemTitle, {
        isSideBarExpanded: isOpen,
        title: t('title.student'),
        Icon: PersonOutlineIcon,
        showWarningIcon: warningNotices.some(function (notice) {
          return notice.regarding === 'student';
        })
      }),
      hideChevron: hideChevron,
      children: _jsx(AccordionItemContent, {
        isOpen: isOpen,
        children: _jsx(StudentDetails, {
          copyEnabled: copyEnabled,
          hiddenSections: hiddenSections
        })
      })
    }, "Student"), !(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('educationBackground')) && _jsx(Accordion.Item, {
      id: "Education background",
      title: _jsx(AccordionItemTitle, {
        isSideBarExpanded: isOpen,
        title: t('title.educationBackground'),
        Icon: BuildingOutlineIcon,
        showWarningIcon: warningNotices.some(function (notice) {
          return notice.regarding === 'education';
        })
      }),
      hideChevron: hideChevron,
      children: _jsx(AccordionItemContent, {
        isOpen: isOpen,
        children: _jsx(EducationBackground, {
          copyEnabled: copyEnabled
        })
      })
    }, "Education background"), _jsx(Accordion.Item, {
      id: "Exams",
      title: _jsx(AccordionItemTitle, {
        isSideBarExpanded: isOpen,
        title: t('title.exams'),
        Icon: ClipboardOutlineIcon,
        showWarningIcon: warningNotices.some(function (notice) {
          return notice.regarding === 'exams';
        })
      }),
      hideChevron: hideChevron,
      children: _jsx(AccordionItemContent, {
        isOpen: isOpen,
        children: _jsx(ExamDetails, {
          copyEnabled: copyEnabled,
          hiddenSections: hiddenSections
        })
      })
    }, "Exams"), orderItem && _jsx(Accordion.Item, {
      id: "Payment details",
      title: _jsx(AccordionItemTitle, {
        isSideBarExpanded: isOpen,
        title: t('title.paymentDetails'),
        Icon: MoneyDollarOutlineIcon,
        showWarningIcon: warningNotices.some(function (notice) {
          return notice.regarding === 'payment';
        })
      }),
      hideChevron: hideChevron,
      children: _jsx(AccordionItemContent, {
        isOpen: isOpen,
        children: _jsx(PaymentDetails, {
          copyEnabled: copyEnabled,
          hideOrderLink: hiddenSections === null || hiddenSections === void 0 ? void 0 : hiddenSections.includes('paymentDetails.orderLink'),
          paymentDetailsButton: paymentDetailsButton
        })
      })
    }, "Payment details"), recruitmentPartner && !(hiddenSections !== null && hiddenSections !== void 0 && hiddenSections.includes('recruitmentPartner')) && _jsx(Accordion.Item, {
      id: "Recruitment partner",
      title: _jsx(AccordionItemTitle, {
        isSideBarExpanded: isOpen,
        title: t('title.recruitmentPartner'),
        Icon: PersonTieOutlineIcon,
        showWarningIcon: warningNotices.some(function (notice) {
          return notice.regarding === 'recruitment_partner';
        })
      }),
      hideChevron: hideChevron,
      children: _jsx(AccordionItemContent, {
        isOpen: isOpen,
        children: _jsx(RecruitmentPartnerDetails, {
          copyEnabled: copyEnabled
        })
      })
    }, "Recruitment partner")]
  });
}
function useHandleAccordionOpen(_ref7) {
  var allowMultipleOpen = _ref7.allowMultipleOpen,
    onOpenChange = _ref7.onOpenChange;
  var _useState3 = useState(['Student']),
    _useState4 = _slicedToArray(_useState3, 2),
    accordionValue = _useState4[0],
    setAccordionValue = _useState4[1];
  var _useEventTracker3 = useEventTracker({
      group: 'Single Application V2'
    }),
    trackEvent = _useEventTracker3.trackEvent;
  var trackSectionExpanded = function trackSectionExpanded(_ref8) {
    var sectionName = _ref8.sectionName,
      isExpanded = _ref8.isExpanded;
    trackEvent({
      event: 'Single Application V2-Sidebar-Clicked To Expand/ Collapse Sidebar Section',
      data: {
        sectionName: sectionName,
        sectionExpanded: isExpanded
      }
    });
  };
  var handleMultipleToggle = function handleMultipleToggle(newAccordionValue) {
    assert(Array.isArray(accordionValue));
    assert(Array.isArray(newAccordionValue));
    var openedItem = newAccordionValue.filter(function (item) {
      return !accordionValue.includes(item);
    })[0];
    var closedItem = accordionValue.filter(function (item) {
      return !newAccordionValue.includes(item);
    })[0];
    setAccordionValue(newAccordionValue);
    if (openedItem) {
      trackSectionExpanded({
        sectionName: openedItem,
        isExpanded: true
      });
    }
    if (closedItem) {
      trackSectionExpanded({
        sectionName: closedItem,
        isExpanded: false
      });
    }
  };
  var handleSingleToggle = function handleSingleToggle(newAccordionValue) {
    if (accordionValue.length) {
      trackSectionExpanded({
        sectionName: accordionValue[0],
        isExpanded: false
      });
    }
    var filteredValue = newAccordionValue.filter(function (value) {
      return !accordionValue.includes(value);
    });
    if (newAccordionValue.length) {
      trackSectionExpanded({
        sectionName: filteredValue[0],
        isExpanded: true
      });
    }
    setAccordionValue(filteredValue);
  };
  var handleAccordionSectionExpandedToggle = function handleAccordionSectionExpandedToggle(newAccordionValue) {
    if (allowMultipleOpen) {
      handleMultipleToggle(newAccordionValue);
    } else {
      handleSingleToggle(newAccordionValue);
    }
    onOpenChange(true);
  };
  return {
    accordionValue: accordionValue,
    handleAccordionSectionExpandedToggle: handleAccordionSectionExpandedToggle
  };
}

// Hack to get the type of an icon, all icons should be the same type.

function AccordionItemTitle(_ref9) {
  var Icon = _ref9.Icon,
    title = _ref9.title,
    isSideBarExpanded = _ref9.isSideBarExpanded,
    _ref9$showWarningIcon = _ref9.showWarningIcon,
    showWarningIcon = _ref9$showWarningIcon === void 0 ? false : _ref9$showWarningIcon;
  return _jsx(Bleed, {
    mx: isSideBarExpanded ? 0 : 2,
    children: _jsxs(Flex, {
      direction: isSideBarExpanded ? 'row' : 'column',
      gap: isSideBarExpanded ? 4 : 0,
      align: "center",
      py: 2,
      children: [_jsx("div", {
        style: {
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center'
        },
        children: _jsx(Icon, {})
      }), _jsx("div", {
        style: {
          overflow: 'hidden',
          whiteSpace: isSideBarExpanded ? 'nowrap' : undefined
        },
        children: _jsx(Text, {
          align: "center",
          variant: isSideBarExpanded ? 'titleS' : 'bodyS',
          children: title
        })
      }), showWarningIcon && _jsx("div", {
        style: {
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center'
        },
        children: _jsx(WarningOutlineIcon, {
          intent: "warning"
        })
      })]
    })
  });
}
function AccordionItemContent(_ref10) {
  var children = _ref10.children,
    isOpen = _ref10.isOpen;
  if (!isOpen) {
    return null;
  }
  return _jsx(Bleed, {
    my: 2,
    children: children
  });
}
export function useSidebar() {
  var _useContext3 = useContext(SidebarContext),
    isOpen = _useContext3.isOpen,
    onOpenChange = _useContext3.onOpenChange;
  return {
    isSidebarOpen: isOpen,
    setIsSidebarOpen: onOpenChange
  };
}